import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciMenuComponent } from './luci-menu.component';



@NgModule({
  declarations: [LuciMenuComponent],
  exports: [LuciMenuComponent],
  imports: [
    CommonModule
  ]
})
export class LuciMenuModule { }
